module.exports = __webpack_public_path__ + "static/media/remove-format.cd9179ca.svg";